import { render, staticRenderFns } from "./GwExport.html?vue&type=template&id=116fc70a&scoped=true&external"
import script from "./GwExport.vue?vue&type=script&lang=js"
export * from "./GwExport.vue?vue&type=script&lang=js"
import style0 from "./GwExport.scss?vue&type=style&index=0&id=116fc70a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116fc70a",
  null
  
)

export default component.exports